import * as THREE from 'three'
import Honor from './Honor'
import TweenLite from 'gsap/TweenLite'

import honorsSih2019SlideASources from '../../../models/honors/sih2019/slideA.jpg'
import honorsSih2019SlideBSources from '../../../models/honors/sih2019/slideB.jpg'
import honorsSih2019SlideCSources from '../../../models/honors/sih2019/slideC.jpg'

import honorsNationalHack2019SlideASources from '../../../models/honors/nationalHack2019/slideA.jpg'
import honorsNationalHack2019SlideBSources from '../../../models/honors/nationalHack2019/slideB.jpg'
import honorsNationalHack2019SlideCSources from '../../../models/honors/nationalHack2019/slideC.jpg'
import honorsNationalHack2019SlideDSources from '../../../models/honors/nationalHack2019/slideD.jpg'

import honorsTn2022SlideASources from '../../../models/honors/tn2022/slideA.jpg'
import honorsTn2022SlideBSources from '../../../models/honors/tn2022/slideB.jpg'
import honorsTn2022SlideCSources from '../../../models/honors/tn2022/slideC.jpg'

import honorsSheffield2022SlideASources from '../../../models/honors/sheffield2022/slideA.jpg'
import honorsSheffield2022SlideBSources from '../../../models/honors/sheffield2022/slideB.jpg'
import honorsSheffield2022SlideCSources from '../../../models/honors/sheffield2022/slideC.jpg'

import honorsTn2020SlideASources from '../../../models/honors/tn2020/slideA.jpg'
import honorsTn2020SlideBSources from '../../../models/honors/tn2020/slideB.jpg'
import honorsTn2020SlideCSources from '../../../models/honors/tn2020/slideC.jpg'

import honorsNec2019SlideASources from '../../../models/honors/nec2019/slideA.jpg'
import honorsNec2019SlideBSources from '../../../models/honors/nec2019/slideB.jpg'
import honorsNec2019SlideCSources from '../../../models/honors/nec2019/slideC.jpg'

export default class HonorSection
{
    constructor(_options)
    {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.camera = _options.camera
        this.passes = _options.passes
        this.objects = _options.objects
        this.areas = _options.areas
        this.zones = _options.zones
        this.starTiles = _options.starTiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        // Debug
        if(this.debug)
        {
            this.debugFolder = this.debug.addFolder('honors')
            this.debugFolder.open()
        }

        // Set up
        this.items = []

        this.interDistance = 24
        this.positionRandomess = 5
        this.projectHalfWidth = 9

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false
        this.container.updateMatrix()

        // this.setGeometries()
        this.setMeshes()
        this.setList()
        this.setZone()

        // Add all project from the list
        for(const _options of this.list)
        {
            this.add(_options)
        }
    }

    setGeometries()
    {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneBufferGeometry(16, 8)
    }

    setMeshes()
    {
        this.meshes = {}

        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 0.5), new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.resources.items.areaOpenTexture }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setList()
    {
        this.list = [
            {
                name: 'SIH 2019',
                imageSources:
                [
                    honorsSih2019SlideASources,
                    honorsSih2019SlideBSources,
                    honorsSih2019SlideCSources,
                ],
                floorTexture: this.resources.items.honorsSih2019FloorTexture,
                link:
                {
                    href: 'https://contact.lilaavinoth.com',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: true,
                distinctions:
                [
                    // { type: 'fwa', x: 3.95, y: 4.15 }
                ]
            },
            {
                name: 'National Hackathon 2019',
                imageSources:
                [
                    honorsNationalHack2019SlideASources,
                    honorsNationalHack2019SlideBSources,
                    honorsNationalHack2019SlideCSources,
                    honorsNationalHack2019SlideDSources
                ],
                floorTexture: this.resources.items.honorsNationalHack2019FloorTexture,
                link:
                {
                    href: 'https://contact.lilaavinoth.com',
                    x: - 4.8,
                    y: - 4,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: true,
                distinctions:
                [
                    // { type: 'awwwards', x: 3.95, y: 4.15 },
                    // { type: 'fwa', x: 5.6, y: 4.15 }
                ]
            },
            {
                name: 'TNSI 2022',
                imageSources:
                [
                    honorsTn2022SlideASources,
                    honorsTn2022SlideBSources,
                    honorsTn2022SlideCSources
                ],
                floorTexture: this.resources.items.honorsTn2022FloorTexture,
                link:
                {
                    href: 'https://youtu.be/gTahAJ8uoRA',
                    x: - 5.2,
                    y: - 8,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: false,
                distinctions:
                [
                ]
            },
            {
                name: 'Sheffield 2022',
                imageSources:
                [
                    honorsSheffield2022SlideASources,
                    honorsSheffield2022SlideBSources,
                    honorsSheffield2022SlideCSources
                ],
                floorTexture: this.resources.items.honorsSheffield2022Texture,
                link:
                {
                    href: 'https://contact.lilaavinoth.com',
                    x: - 4.8,
                    y: - 3.3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: true,
                distinctions:
                [
                    // { type: 'awwwards', x: 3.95, y: 4.15 },
                    // { type: 'fwa', x: 5.6, y: 4.15 },
                    // { type: 'cssda', x: 7.2, y: 4.15 }
                ]
            },
            {
                name: 'TNSI 2020',
                imageSources:
                [
                    honorsTn2020SlideASources,
                    honorsTn2020SlideBSources,
                    honorsTn2020SlideCSources
                ],
                floorTexture: this.resources.items.honorsTn2020FloorTexture,
                link:
                {
                    href: 'https://contact.lilaavinoth.com',
                    x: - 4.8,
                    y: - 4.2,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: true,
                distinctions:
                [
                    // { type: 'awwwards', x: 3.95, y: 4.15 },
                    // { type: 'fwa', x: 5.6, y: 4.15 },
                    // { type: 'cssda', x: 7.2, y: 4.15 }
                ]
            },
            {
                name: 'NEC 2019',
                imageSources:
                [
                    honorsNec2019SlideASources,
                    honorsNec2019SlideBSources,
                    honorsNec2019SlideCSources
                ],
                floorTexture: this.resources.items.honorsNec2019FloorTexture,
                link:
                {
                    href: 'https://contact.lilaavinoth.com',
                    x: - 4.8,
                    y: - 3,
                    halfExtents:
                    {
                        x: 3.2,
                        y: 1.5
                    }
                },
                hidden: true,
                distinctions:
                [
                    // { type: 'awwwards', x: 3.95, y: 4.15 },
                    // { type: 'fwa', x: 5.6, y: 4.15 },
                    // { type: 'cssda', x: 7.2, y: 4.15 }
                ]
            },
        ]
    }

    setZone()
    {
        const totalWidth = this.list.length * (this.interDistance / 2)

        const zone = this.zones.add({
            position: { x: this.x + totalWidth - this.projectHalfWidth - 6, y: this.y },
            halfExtents: { x: totalWidth, y: 12 },
            data: { cameraAngle: 'projects' }
        })

        zone.on('in', (_data) =>
        {
            this.camera.angle.set(_data.cameraAngle)
            TweenLite.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, 2, { x: 0 })
            TweenLite.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, 2, { y: 0 })
        })

        zone.on('out', () =>
        {
            this.camera.angle.set('default')
            TweenLite.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, 2, { x: this.passes.horizontalBlurPass.strength })
            TweenLite.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, 2, { y: this.passes.verticalBlurPass.strength })
        })
    }

    add(_options)
    {
        const x = this.x + this.items.length * this.interDistance
        let y = this.y
        if(this.items.length > 0)
        {
            y += (Math.random() - 0.5) * this.positionRandomess
        }

        // Create project
        const project = new Honor({
            time: this.time,
            resources: this.resources,
            objects: this.objects,
            areas: this.areas,
            geometries: this.geometries,
            meshes: this.meshes,
            debug: this.debugFolder,
            x: x,
            y: y,
            ..._options
        })

        this.container.add(project.container)

        // Add star tiles
        if(this.items.length >= 1)
        {
            const previousProject = this.items[this.items.length - 1]
            const start = new THREE.Vector2(previousProject.x + this.projectHalfWidth, previousProject.y)
            const end = new THREE.Vector2(project.x - this.projectHalfWidth, project.y)
            const delta = end.clone().sub(start)
            this.starTiles.add({
                start: start,
                delta: delta
            })
        }

        // Save
        this.items.push(project)
    }
}
